import "./modules/common";
import { LoginForm } from "spiritweb.packages.web-account";
import VueApp from "~/Scripts/new/vueApp";

new VueApp( {
  name: "Login",
  components: {
    LoginForm,
  },
  methods: {
    onLogin ( webAccountId ) {
      const urlSearchParams = new URLSearchParams( window.location.search );
      const params = Object.fromEntries( urlSearchParams.entries() );

      const returnUrl = params.r;

      if ( webAccountId && returnUrl ) {
        const newUrl = new URL( returnUrl );
        newUrl.searchParams.append( "id", webAccountId );

        // Only open a new tab if in Chrome as Firefox will show a
        // popup warning dialogue
        if ( window.chrome ) {
          window.open( newUrl.href, "_blank" );
        } else {
          window.location.href = newUrl.href;
        }
      }
    },
  },
} );
